export const VIDFLEET_SD_CARD_STATUS_REQUEST = "VIDFLEET_SD_CARD_STATUS_REQUEST";
export const VIDFLEET_SD_CARD_STATUS_RESULT = "VIDFLEET_SD_CARD_STATUS_RESULT";